/* eslint-disable no-unused-vars */
import React from 'react';
import { Progress, Row, Col } from 'antd';

interface progressBarProps {
  data: any;
  source?: string;
  brandcount?: number;
}

function ProgressBar(props: progressBarProps) {
  const { data, source, brandcount } = props;

  function removePercentSign(data: any) {
    const number = parseFloat(data.replace('%', ''));
    return number;
  }

  return data ? (
    <Row justify="center" align="middle">
      <Col>
        <div
          style={{
            textAlign: 'center',
            height: source === 'healthCheck' ? '100px' : 'auto',
          }}
        >
          <Progress
            className={source === 'healthCheck' ? 'healthcheck-progress' : ''}
            width={source === 'healthCheck' ? 170 : 225}
            type="dashboard"
            percent={
              source !== 'healthCheck'
                ? data?.wastePercentage + data?.inventoryPercentage
                : removePercentSign(data)
            }
            strokeColor="#F8F7FA"
            success={{
              percent:
                source !== 'healthCheck'
                  ? data?.wastePercentage
                  : removePercentSign(data),
              strokeColor: '#F9AB01',
            }}
            format={
              source !== 'healthCheck'
                ? () => (
                    <>
                      <div className="wastage-progress">{'Total Wastage'}</div>
                      <div className="wastage-percentage">{`${data?.wastePercentage}%`}</div>
                    </>
                  )
                : undefined
            }
          />
          {source !== 'healthCheck' ? (
            <div
              className="wastage-progress-tags"
              style={{
                marginTop: 6,
                display: 'flex',
                justifyContent: 'center',
                gap: 12,
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <span className="wastage-dots"></span>
                <span className="wastage-tooltip">{`Wastage: ${data?.wastePercentage}%`}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <span className="wastage-dots dot2"></span>
                <span className="wastage-tooltip">{`Inventory: ${data?.inventoryPercentage}%`}</span>
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
      </Col>
    </Row>
  ) : (
    <div
      className={`no-data-graph${
        source === 'healthCheck' ? ' progress-nodata' : ''
      }`}
    >
      No data to display
    </div>
  );
}

export default ProgressBar;
